import FinishStage from './FinishStage'

export default FinishStage
